import $ from 'static/script/libs/jquery';
import context from 'static/script/app/ui/checkout2/context/context';
riot.tag2('checkout-summary', '<div class="show-xlarge"> <div id="sticker"> <div class="co-panel"> <h2>{t(\'checkout_summary_title\')}</h2> <div class="co-content d-flex flex-column"> <div class="d-flex flex-row justify-content-between"> <div class="">{t(\'checkout_summary_objectCostTitle\')}</div> <div class="">{t(\'checkout_summary_objectCost\', {itemPrice: model.itemPrice})}</div> </div> <div class="d-flex flex-row justify-content-between"> <div>{t(\'checkout_summary_shippingCostTitle\')}</div> <div>{t(\'checkout_summary_shippingCost\', {shippingCost: model.shippingCost})}</div> </div> <div class="d-flex flex-row justify-content-between" if="{model.discountAmount> 0}"> <div>{t(\'checkout_summary_discountTitle\')}</div> <div class="co-discount">{t(\'checkout_summary_discount\', {discountAmount: model.discountAmount})}</div> </div> <div class="co-summary-divider"></div> <div class="co-summary-h1 d-flex flex-row justify-content-between"> <div>{t(\'checkout_summary_toPayTitle\')}</div> <div class="">{t(\'checkout_summary_toPay\', {amount: model.shippingCost + model.itemPrice - model.discountAmount})}</div> </div> </div> </div> <div class="co-panel co-payment-button no-border"> <button class="btn btn-lg btn-success btn-fluid {disabled:!isCheckoutValid}" onclick="{confirmButtonClick}">{t(\'checkout_summary_pay\')}</button> </div> </div> </div> <div class="hide-xlarge co-content"> <div class="co-summary-centered">{t(\'checkout_summary_toPayTitle\')}</div> <div class="co-summary-centered co-summary-h1">{t(\'checkout_summary_toPay\', {amount: model.shippingCost + model.itemPrice - model.discountAmount})}</div> <div class="co-summary-centered co-payment-button"> <button class="btn btn-lg btn-success btn-fluid {disabled:!isCheckoutValid}" onclick="{confirmButtonClick}">{t(\'checkout_summary_pay\')}</button> </div> </div>', '', '', function(opts) {
        this.context = context;
        this.model = opts.model;
        this.context.observable.on('shipping-changed', function (item) {
            this.model.shippingCost = item.shippingCost;
            this.model.shippingType = item.shippingType;
            this.update();
        }.bind(this));

        this.context.observable.on('payment-valid', function () {
            if (this.context.payment.selectedPaymentType && this.context.shipping.selectedShippingType) {
                this.isCheckoutValid = true;
            }
            this.update();
        }.bind(this));

        this.context.observable.on('payment-not-valid', function () {
            this.isCheckoutValid = false;
            this.update();
        }.bind(this));

        this.confirmButtonClick = function () {
            if (!this.isCheckoutValid) return;

            var model = {
                itemId: this.model.itemId,
                purchaseOrderId: this.model.purchaseOrderId,
                shippingType: this.model.shippingType,
                shippingCost: this.model.shippingCost
            };

            this.context.payment.performPayment(model, this.model.performPaymentUrl);
        }

        this.makeStickyDiv = function () {
            var s = $("#sticker");
            var pos = s.position();
            $(window).scroll(function () {
                var windowpos = $(window).scrollTop();
                if (windowpos >= pos.top - 50) {
                    s.addClass("co-summary-stick");
                } else {
                    s.removeClass("co-summary-stick");
                }
            });
        }

        this.on('mount', function () {
            this.makeStickyDiv();
        });
});
